

import { Button, Card, Col, Form, message, Radio, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../../comps/pageHeader";
import { fetchSingleLesson } from "../lesson/singleLessonSlice";
// import { fetchSelectCategories } from "../categories/categoriesSlice";
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './quillAdd.css'
// import FormItem from "antd/es/form/FormItem";
import { addExercice } from "./addExerciceSlice";
import { CreateNonCommonQst, setAddNonCommonQstResult } from "./addNonCommonQstSlice ";
import '../dashboard/dashboard.css'
import ExerciceQuestionsWithProps from "./exerciceQuestionsWithPropos";
let Inline = Quill.import('blots/inline');
class BoldBlot extends Inline { }
BoldBlot.blotName = 'bold';
BoldBlot.tagName = 'b';
Quill.register(BoldBlot);
class ItalicBlot extends Inline { }
ItalicBlot.blotName = 'italic';
ItalicBlot.tagName = 'i';
Quill.register(ItalicBlot);

const modules = {

    toolbar: [
        ['bold', 'italic', 'underline'],
    ],
}
const formats = [

    'bold', 'italic', 'underline'
]

const AddNonCommunExo = () => {
    const { Text } = Typography



    const { id, seq, theme } = useParams();
    const dispatch = useDispatch();
    let navigate = useNavigate();

    const fetchSingleLessonResult = useSelector((state) => state.lesson.fetchSingleLessonResult);

    const addExerciceResult = useSelector((state) => state.addExo.addExerciceResult);
    // const isAddingExercice = useSelector((state) => state.addExo.isAddingExercice);

    // const isAddingCommonQst = useSelector((state) => state.addNonCommonQst.isAddingCommonQst);
    const addNonCommonQstResult = useSelector((state) => state.addNonCommonQst.addNonCommonQstResult);

    const fetchThemesResult = useSelector((state) => state.dashboard.fetchThemesResult);


    const [exerciceForm, setExerciceForm] = useState({ statement: "", propositions: [], lesson: id, theme: null });
    const [questionsForm, setQuestionsForm] = useState({ questions: [], moduleSeq: seq, exerciceId: null, questionType: "fill" });

    const [defisCheck, setDefisCheck] = useState(true);
    const [questionType, setQuestionType] = useState("fill");
    const [questionTypeRadio, setQuestionTypeRadio] = useState(true);

    const [displayTheme, setDisplayTheme] = useState("");

    const [errorIndexInput, setErrorIndexInput] = useState([]);
    const [errorIndexSelect, setErrorIndexSelect] = useState([]);

    const regex = /^[^()]*\([^()]+\)[^()]*$/;
    useEffect(() => {
        if (!fetchSingleLessonResult) {

            dispatch(fetchSingleLesson({ id, seq }));

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [seq]);
    useEffect(() => {
        if (addExerciceResult) {

            // console.log("hjhjjh", { ...questionsForm, exerciceId: addExerciceResult._id });
            setQuestionsForm({ ...questionsForm, exerciceId: addExerciceResult._id });
            dispatch(CreateNonCommonQst({ ...questionsForm, exerciceId: addExerciceResult._id }))

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addExerciceResult]);
    useEffect(() => {
        if (theme && fetchThemesResult) {
            const themeID = fetchThemesResult.data.find(themed => themed.type === theme);
            if (themeID) {
                setDisplayTheme(themeID.displayName)
                setExerciceForm({ ...exerciceForm, theme: themeID._id });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [theme, fetchThemesResult]);
    useEffect(() => {
        if (addNonCommonQstResult) {
            dispatch(setAddNonCommonQstResult(null))
            navigate(-1)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addNonCommonQstResult]);

    const handleQstTypeChanege = (e) => {
        if (e.target.value === "replace") {
            setDefisCheck(false)
        } else {
            setDefisCheck(true)
        }
        setQuestionType(e.target.value);
        setQuestionsForm({ ...questionsForm, questionType: e.target.value })
    };

    const handleConfirmExercice = (e) => {
        let checkExoSyntax = { ...questionsForm }
        let errorSyntaxIndex = []
        let errorEmptyIndex = []
        let errorSelectIndex = []
        // eslint-disable-next-line array-callback-return
        checkExoSyntax.questions.map((qst, index) => {
            if (qst.content[0].trim() === "") {
                errorEmptyIndex.push(index + 1)

            } else {

                if (questionType === "fill" && !((/^[^*]*\*[^*]*$/.test(qst.content[0])))) {
                    errorSyntaxIndex.push(index + 1)
                }
                if (questionType === "replace" && !(regex.test(qst.content[0]))) {
                    errorSyntaxIndex.push(index + 1)
                }
                if (!(typeof (qst.correction) === "number")) {
                    errorSelectIndex.push(index + 1)
                }
            }
        })
        if (errorSyntaxIndex.length > 0 || errorEmptyIndex.length > 0) {
            setErrorIndexSelect([])
            if (errorSyntaxIndex.length > 0) {
                if (questionType === "replace") {

                    message.error('Veuillez vérifier les ( )  dans les questions : ' + errorSyntaxIndex.join(" | ") )
                } else {
                    message.error('Les questions ' + errorSyntaxIndex.join(" | ") + ' doivent contenir une seule * ')

                }
            }
            if (errorEmptyIndex.length > 0) {

                message.error('Les questions ' + errorEmptyIndex.join(" | ") + ' sont vides ')

            }
            // console.log('errorEmptyIndex ', errorEmptyIndex);
            setErrorIndexInput([...new Set([...errorSyntaxIndex, ...errorEmptyIndex])])
        } else {
            console.log('errorSelectIndex ', errorSelectIndex);
            setErrorIndexInput([])
            if (errorSelectIndex.length > 0) {
                message.error('Veuillez sélectionner les réponses des questions : ' + errorSelectIndex.join(" | "))
                setErrorIndexSelect(errorSelectIndex)
                // console.log('errorIndexSelect  ',errorSelectIndex);

            }
            else {
                if (addExerciceResult) {

                    // console.log("hjhjjh", { ...questionsForm, exerciceId: addExerciceResult._id });
                    setQuestionsForm({ ...questionsForm, exerciceId: addExerciceResult._id });
                    dispatch(CreateNonCommonQst({ ...questionsForm, exerciceId: addExerciceResult._id }))

                } else {

                    dispatch(addExercice(exerciceForm));
                }
            }
        }
    };

    return (
        <>
            {fetchSingleLessonResult ?
                <PageHeader title={"Ajouter L'exercice du thème " + displayTheme}
                    breadcrumbItems={["Création de Contenu", "Modules", "Module " + seq, "leçon " + fetchSingleLessonResult.lesson.seq, "Ajouter un exercice"]} />
                : null}
            <Card title='Ajouter Exercice à Réponses non Communes'
                className="CardExo"
                style={{ width: "95%", margin: "24px" }}
                bodyStyle={{ padding: "24px 80px 24px 80px" }}
                actions={[
                    <Button>Annuler</Button>,
                    <Button type="primary" onClick={handleConfirmExercice}>Confirmer</Button>,

                ]}
            >
                <Form layout="horizontal">
                    <Form.Item label="Énoncé : " labelAlign="right"
                        labelCol={{ span: 24, offset: 12 }}
                    >
                        <ReactQuill theme="snow" className='quillSTATMENT'
                            value={exerciceForm.statement}

                            modules={modules}
                            formats={formats}
                            onChange={(value) => {
                                setExerciceForm({
                                    ...exerciceForm,
                                    statement: value,
                                });
                            }}
                        >
                        </ReactQuill>
                    </Form.Item>

                    <Row >
                        <Col span={8}>
                            <Text style={{ fontWeight: "bold", fontSize: "15px" }}>Questions  :    </Text>

                        </Col>
                        <Col span={15}>
                            <Radio.Group
                                onChange={handleQstTypeChanege}
                                value={questionType}
                                disabled={!questionTypeRadio}
                            >
                                <Radio value={"fill"}>Question à remplir</Radio>
                                <Radio value={"replace"}>Question à remplacer</Radio>

                            </Radio.Group>

                        </Col>
                        <Col span={1} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Text style={{ fontWeight: "bold", fontSize: "15px" }}>Défis</Text>
                        </Col>
                    </Row>
                    <Row >
                        <Col span={24}>

                            <ExerciceQuestionsWithProps exerciceForm={exerciceForm} defisCheck={defisCheck} errorIndexInput={errorIndexInput} errorIndexSelect={errorIndexSelect}
                                questionType={questionType} setQuestionType={setQuestionType} questionsForm={questionsForm} setQuestionsForm={setQuestionsForm} setQuestionTypeRadio={setQuestionTypeRadio} />
                        </Col>
                    </Row>

                </Form>
            </Card>
        </>
    );
}

export default AddNonCommunExo;